import { Backdrop, CircularProgress } from "@mui/material";
import { Button, DatePicker, Form, Input, Modal, Radio } from "antd";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { UpdateSoftware, axiosErrorMessages } from "../../../API/api";
import axios, { AxiosError } from "axios";

interface AddEditSoftwareType {
  
  isOs:boolean;
    editData:any;
    handleClose: (data: boolean) => void;

  }
  const EditSoftware: React.FC<AddEditSoftwareType> = ({ isOs,editData,handleClose }) => {
    const [employeeForm] = Form.useForm();
    const [isOpen,setIsOpen] = useState<boolean>(true)
    const [isPaid,setIsPaid] = useState<string>("")
    useEffect(() => {
        setFormData();
      }, []);
      const setFormData = () => {
    
        employeeForm.setFieldsValue({
            softwareName: editData.softwareName,
            companyName: editData.companyName,
       
        });
      };
    const [isLoading,setIsLoading] = useState<boolean>(false)
    const employeeEditHandler = (rowData:any) => {
      if(rowData.softwareName.trim() && rowData.companyName.trim()) {
        const saveData = {
          isOS:isOs,
          softwareId:editData.softwareId,
          softwareName:rowData.softwareName.trim(),
          companyName:rowData.companyName.trim()
        }
        UpdateSoftware(saveData)
        .then((response:any)  =>{
          enqueueSnackbar("Updated Successfully",{ variant: 'success', anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },})
          setIsOpen(false)
          handleClose(true)
        }).catch((error:any)  =>  {
          if(error.response.data.errors.Software[0])
          enqueueSnackbar(error.response.data.errors.Software[0],{ variant: 'error', anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },})
          else{
            let errorMsg;
            if (axios.isAxiosError(error)) {
              const axiosError = error as AxiosError;
              errorMsg = axiosErrorMessages(axiosError);
            } else {
              errorMsg = error.message;
            }
            enqueueSnackbar(errorMsg, {
              variant: "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            });
          }
        })
      }else 
      enqueueSnackbar("Enter Values",{ variant: 'error', anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },})
     
    }
    const handleCloseAddEditPopup = () => {
        setIsOpen(false)
        handleClose(true)

    }
    return <>


<Modal
              footer={null}
              title="Edit Software"
              open={isOpen}
              onCancel={handleCloseAddEditPopup}
              maskClosable={false}
            >
   <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
    <Form
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      layout="horizontal"
      form={employeeForm}
      onFinish={employeeEditHandler}
      style={{ maxWidth: 600 }}
    >
      <Form.Item           rules={[{ required: true, message: "Enter Name" }]}
 label="Name" name="softwareName" className="input-edit-row">
        <Input
          className="input-edit"
        />
      </Form.Item>
      <Form.Item           rules={[{ required: true, message: "Enter Company Name" }]}
 label="Company" name="companyName" className="input-edit-row">
        <Input
          className="input-edit"
        />
      </Form.Item>



      <Form.Item wrapperCol={{ span: 24 }}>
        <Button className="pm-btn" type="primary" htmlType="submit">
          Save
        </Button>
      </Form.Item>
    </Form>

                </Modal>

 
  </>
}

export default EditSoftware;